import { createOrderParams } from './orderUtils'

// NOTE : Please keep the default behaviors here in line with Shift4 use cases. Conditionalize
// FreedomPay specific behaviors.

const responseStatuses = {
  1: 'No response data exists',
  2: 'Card reader still offline',
  3: 'Transaction declined during replay',
  4: 'Transaction approved',
  5: 'Voided without communicating with the server',
}

const isPaxResponse = (data) => data.reasonText || data.message

const responseRefNum = (data) => {
  if (isPaxResponse(data)) return data.refNum

  return data.responseStatus
}

export const statusCheckComplete = (data) => {
  if (!data) return false

  const responseRef = responseRefNum(data)

  if (!isPaxResponse(data)) return [3, 4].includes(responseRef)

  return !!(responseRef && (responseRef <= 5000 || responseRef >= 9001))
}

export const responseStatusString = (responseStatus) => responseStatuses[responseStatus]

export const approvedOfflineNoResponse = (data) => {
  const responseRef = responseRefNum(data)

  return !responseRef && (data.reasonText === 'NOT FOUND' || data.message === 'NOT FOUND')
}

export const approvedOfflineThenDeclined = (data) => {
  const responseRef = responseRefNum(data)
  if (!isPaxResponse(data)) {
    return responseRef === 3
  }

  if (responseRef) return responseRef >= 9001 && responseRef <= 9999

  // TODO(mkramerl): This path is for legacy compatibility. RefNum path should be the primary one
  // for new applications. Remove this path at some point.
  if (data.reasonText === 'DECLINE' || data.message === 'DECLINE') {
    return true
  }

  if (data.reasonText === 'APPROVED OFFLINE' || data.message === 'APPROVED OFFLINE') {
    return data?.receiptData?.approvalCode === 'D'
  }

  return false
}

export const isOfflineApproval = (order) => {
  const cardReaderData = order?.cardReaderData ?? {}
  const userAttributes = createOrderParams(order)?.userAttributes ?? order?.userAttributes ?? {}
  const requestId = cardReaderData.requestId || ''

  if (order.payments?.some((payment) => payment?.userAttributes?.isOfflineApproval)) return true

  if (order.neededToBeVoidedAuthPayment?.[0]?.userAttributes?.isOfflineApproval) return true

  return cardReaderData?.isOfflineApproval || userAttributes?.isOfflineApproval || requestId.substring(0, 3) === '00Y'
}
